export interface SiteCopy {
    home_fallback_title: string;
    home_fallback_subtitle: string;
    works_intro_title: string;
    works_intro_body: string;
    showreel_heading: string;
    showreel_body: string;
    featured_heading: string;
    process_heading: string;
    services_heading: string;
    clients_heading: string;
    clients_body: string;
    contact_cta_heading: string;
    contact_button_label: string;
    contacts_title: string;
    contacts_subtitle: string;
    project_detail_hidden_title: string;
    project_detail_hidden_body: string;
    project_detail_case_heading: string;
    project_detail_case_body: string;
    footer_brand: string;
    footer_tagline: string;
    footer_naver_url: string;
    footer_terms_label: string;
    footer_privacy_label: string;
    footer_admin_label: string;
}

export const defaultSiteCopy: SiteCopy = {
    home_fallback_title: "Client Operation Server",
    home_fallback_subtitle: "Welcome to our platform",
    works_intro_title: "",
    works_intro_body: "",
    showreel_heading: "기획의 밀도와 화면의 완성도를 한 번에 보여줍니다.",
    showreel_body: "브랜드, 제품, 캠페인 영상의 톤을 빠르게 파악할 수 있는 대표 영상입니다.",
    featured_heading: "성과를 만드는 대표 작업",
    process_heading: "예측 가능한 제작 흐름",
    services_heading: "브랜드 목적에 맞춘 영상 제작 범위",
    clients_heading: "다양한 브랜드 맥락에 맞춰 작업합니다.",
    clients_body: "업종의 언어와 고객의 구매 흐름을 먼저 이해하고, 영상이 쓰일 채널과 목적에 맞춰 결과물을 설계합니다.",
    contact_cta_heading: "레퍼런스, 일정, 예산을 함께 남겨주세요.",
    contact_button_label: "문의하기",
    contacts_title: "Contact Us",
    contacts_subtitle: "궁금한 점이 있으시거나 문의사항이 있으시면 언제든지 연락주세요.\n최대한 빠른 시일 내에 답변드리겠습니다.",
    project_detail_hidden_title: "프로젝트 상세 보기가 숨겨져 있습니다.",
    project_detail_hidden_body: "관리자 설정에서 프로젝트 상세 보기를 다시 켜면 이 페이지가 표시됩니다.",
    project_detail_case_heading: "영상의 목적이 먼저 보이도록 구성했습니다.",
    project_detail_case_body: "단순한 결과물 나열을 넘어, 브랜드가 전달해야 할 메시지와 시청자가 받아들이는 흐름을 기준으로 컷 구성과 리듬을 설계합니다.",
    footer_brand: "NO-ON",
    footer_tagline: "NO:ON STUDIO wants to hear your story, old or new",
    footer_naver_url: "https://naver.me/xv6RdO2D",
    footer_terms_label: "이용약관",
    footer_privacy_label: "개인정보처리방침",
    footer_admin_label: "관리자",
};

export const siteCopyItems: Array<{
    key: keyof SiteCopy;
    label: string;
    multiline?: boolean;
}> = [
    { key: "home_fallback_title", label: "홈 기본 제목" },
    { key: "home_fallback_subtitle", label: "홈 기본 부제" },
    { key: "works_intro_title", label: "Works 전체 소개 제목" },
    { key: "works_intro_body", label: "Works 전체 소개 본문", multiline: true },
    { key: "showreel_heading", label: "대표 쇼릴 제목" },
    { key: "showreel_body", label: "대표 쇼릴 본문", multiline: true },
    { key: "featured_heading", label: "대표 작업 제목" },
    { key: "process_heading", label: "제작 프로세스 제목" },
    { key: "services_heading", label: "서비스 범위 제목" },
    { key: "clients_heading", label: "작업 분야/후기 제목" },
    { key: "clients_body", label: "작업 분야/후기 본문", multiline: true },
    { key: "contact_cta_heading", label: "문의 유도 제목" },
    { key: "contact_button_label", label: "문의 버튼 문구" },
    { key: "contacts_title", label: "문의 페이지 제목" },
    { key: "contacts_subtitle", label: "문의 페이지 설명", multiline: true },
    { key: "project_detail_hidden_title", label: "상세 숨김 안내 제목" },
    { key: "project_detail_hidden_body", label: "상세 숨김 안내 본문", multiline: true },
    { key: "project_detail_case_heading", label: "프로젝트 상세 소개 제목" },
    { key: "project_detail_case_body", label: "프로젝트 상세 소개 본문", multiline: true },
    { key: "footer_brand", label: "푸터 브랜드명" },
    { key: "footer_tagline", label: "푸터 설명", multiline: true },
    { key: "footer_naver_url", label: "푸터 네이버 링크 URL" },
    { key: "footer_terms_label", label: "이용약관 링크 문구" },
    { key: "footer_privacy_label", label: "개인정보처리방침 링크 문구" },
    { key: "footer_admin_label", label: "관리자 링크 문구" },
];
